import { pageTitle } from '@thottbot/shared';
import { useSearchParams } from 'react-router';

function safeNext(next: string | null): string {
  if (!next || !next.startsWith('/') || next.startsWith('//')) return '/';
  return next;
}

export function Login() {
  const [params] = useSearchParams();
  const next = safeNext(params.get('next'));
  return (
    <div className="page">
      <title>{pageTitle('Log in')}</title>
      <h1>Log in</h1>
      <p>
        Thottbot Forever uses your Battle.net account. We only ever see your BattleTag; no password
        is stored here.
      </p>
      <p>
        <a className="button-link" href={`/auth/login?next=${encodeURIComponent(next)}`}>
          <button type="button">Log in with Battle.net</button>
        </a>
      </p>
    </div>
  );
}
